import axios from 'axios';

// единый конструктор DataCenter (стиль smConstructor).
// ActionData: getInfo | saveDiscription | uploadPhoto | deletePhoto
async function dataCenterConstructor({ key, ActionData = 'getInfo', body = null, photoNumber = null, data = null }) {
    let uri = 'https://' + this.ServerUrl + `/dataCenter`;

    let bodyFormData = new FormData();
    if (key) bodyFormData.set('key', key);
    if (ActionData) bodyFormData.set('ActionData', ActionData);
    if (body) bodyFormData.set('body', body);
    if (photoNumber) bodyFormData.set('photoNumber', photoNumber);
    if (data) bodyFormData.set('data', data);
    bodyFormData.set('sessionId', this.lastSessionId);

    let res;

    try {
        res = await axios({
            method: 'post',
            url: uri,
            data: bodyFormData,
            config: {
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                    "Access-Control-Allow-Origin": "*",
                }
            }
        });
    } catch (err) {
        console.log('server error', err);
        return {};
    }

    if (res && res.data && res.data.result && res.data.result.data && res.data.result.status === "Sucess") {
        return res.data.result.data;
    }

    return {};
}

// публичное чтение по ключу (без dataKeys) — для страниц вроде СоФорса-академии
async function getDataCenterPublic({ key, subject = 'user', subjectId }) {
    let uri = 'https://' + this.ServerUrl + `/getDataCenterPublic?key=${key}&subject=${subject}&subjectId=${subjectId}`;

    const answer = await this.standartDataResult(uri);
    if (!answer.error) {
        return answer.result;
    }
    return [];
}

export default {
    dataCenterConstructor,
    getDataCenterPublic
};
